export const DEPLOY_URL = 'https://schedule-team06.netlify.app/';
